import React from "react";
import HomeContainer from "../HomeContainer";

const CoursePlan1 = () => {
  return (
    <HomeContainer>
      <div className="course-plan-container">
        <div>
          <h5 style={{ color: "red" }}>Ai for Gen Z (Machine Learning & Deep Learning with Python)</h5>
          <p>
            <span style={{ color: "#0a9396", fontWeight: "bold" }}>
              Ai For Gen Z (Machine Learning & Deep Learning with Python) কোর্সটি মূলত বাংলাদেশী নতুন প্রজন্মের জন্য ডিজাইন
              করা।
            </span>{" "}
            <span style={{ color: "#005f73" }}>
              বিশেষ করে Gen Z তরুন-তরুনীদের জন্য একটি
              যুগান্তকারী ও আশাব্যঞ্জক কোর্স। অনেকের একটা ভুল ধারণা আছে- শুধু
              সায়েন্স এর ছাত্র/ছাত্রীরাই Data Science/Ai/Machine Learning নিয়ে কাজ করতে
              পারবে; প্রকৃত অর্থে যাদের Intelligence আছে প্রত্যেকেই Artificial
              Intelligence নিয়ে কাজ করার যোগ্যতা রাখে। তোমরা দেশ রক্ষার জন্য যে
              সাহস ও বুদ্ধিমত্তা দেখিয়েছ;
              <span style={{ color: "#0a9396", fontWeight: "bold" }}>
                {" "}
                তার ১০ ভাগের ১ ভাগ সাহস ও বুদ্ধিমত্তা দাও আমরা তোমাদের ভবিষ্যত
                রক্ষার নিশ্চয়তা দিব।
              </span>
            </span>
          </p>
          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹01. Data Science & Artificial Intelligence Introducing
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>
              DS, AI, ML, DL, CV, GenAi, NLP
            </li>
            <li style={{ marginBottom: "6px" }}>
              Supervised, Unsupervised & Reinforcement Learning
            </li>
            <li style={{ marginBottom: "6px" }}>Data vs. Information</li>
            <li style={{ marginBottom: "6px" }}>How works AI</li>
            <li style={{ marginBottom: "6px" }}>
              Regression, Classification, Clustering
            </li>
            <li style={{ marginBottom: "6px" }}>Neural Network</li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹02. Basic Statistics
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>Central Tendency </li>
            <li style={{ marginBottom: "6px" }}>Mean, Median, Mode</li>
            <li style={{ marginBottom: "6px" }}>
              Arithmetic mean, Geometric mean, Harmonic mean
            </li>
            <li style={{ marginBottom: "6px" }}>
              Variance, Co Variance, Standard Deviation{" "}
            </li>
            <li style={{ marginBottom: "6px" }}>Correlation</li>
            <li style={{ marginBottom: "6px" }}>
              Quartiles and Quartile deviation
            </li>
            <li style={{ marginBottom: "6px" }}>Q1, Q2, Q3 and IQR</li>
            <li style={{ marginBottom: "6px" }}>Mean and Mean deviation</li>
            <li style={{ marginBottom: "6px" }}>Simple Random Sampling </li>
            <li style={{ marginBottom: "6px" }}>Systematic Sampling</li>
            <li style={{ marginBottom: "6px" }}>Cluster Sampling </li>
            <li style={{ marginBottom: "6px" }}>Stratified Sampling</li>
            <li style={{ marginBottom: "6px" }}>Important Formulae</li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹03. Basic Probability Distribution
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
          <li style={{ marginBottom: "6px" }}>Basic Probability</li>
          <li style={{ marginBottom: "6px" }}>Probability distribution</li>          
            <li style={{ marginBottom: "6px" }}>Binomial distribution</li>
            <li style={{ marginBottom: "6px" }}>Poisson distribution</li>
            <li style={{ marginBottom: "6px" }}>Exponential distribution</li>
            <li style={{ marginBottom: "6px" }}>Normal distribution</li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹04. Basic LInear Algebra
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>
              Matrix, Dimension, Summation, Subtraction and Multiplication of
              Matrix
            </li>
            <li style={{ marginBottom: "6px" }}>
              Type of Matrix- Diagonal matrix, Inverse Matrix, Column matrix,
              Row matrix, Symmetric matrix, Square matrix, Identity matrix, Null
              matrix, Orthogonal matrix, Unit or identity matrix, Zero matrix,
              Idempotent matrix
            </li>
            <li style={{ marginBottom: "6px" }}>Transpose of a matrix</li>
            <li style={{ marginBottom: "6px" }}>
              Linear transformation of matrix
            </li>
            <li style={{ marginBottom: "6px" }}>Set and Subset</li>
            <li style={{ marginBottom: "6px" }}>Scaler and Vector</li>
            <li style={{ marginBottom: "6px" }}>Column and Row</li>
            <li style={{ marginBottom: "6px" }}>
              Rank, Trace, Diagonal of Matrix
            </li>
            <li style={{ marginBottom: "6px" }}>
              Column Space, Row Space, Null Space
            </li>
            <li style={{ marginBottom: "6px" }}>
              Identity, Diagonal, Sparse & Dense Matrix
            </li>
            <li style={{ marginBottom: "6px" }}>Cramer's Rule</li>
            <li style={{ marginBottom: "6px" }}>Determinant vs Matrix</li>
            <li style={{ marginBottom: "6px" }}>Eigenvalues & Eigenvectors</li>
            <li style={{ marginBottom: "6px" }}>Cramer’s Rule</li>
            <li style={{ marginBottom: "6px" }}>Gauss Elimination</li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹05. Basic Languages, Tools and Framework
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>Basic Python or R</li>
            <li style={{ marginBottom: "6px" }}>Basic OOP</li>
            <li style={{ marginBottom: "6px" }}>IDE Setup</li>
            <li style={{ marginBottom: "6px" }}>VS, VS Code, Kaggle, Colab</li>
            <li style={{ marginBottom: "6px" }}>Variables & Data Types</li>
            <li style={{ marginBottom: "6px" }}>Loops & Control Flow</li>
            <li style={{ marginBottom: "6px" }}>Functions</li>
            <li style={{ marginBottom: "6px" }}>Data Structures</li>
            <li style={{ marginBottom: "6px" }}>Pandas</li>
            <li style={{ marginBottom: "6px" }}>Numpy</li>
            <li style={{ marginBottom: "6px" }}>Matplotlib & Seaborn</li>
            <li style={{ marginBottom: "6px" }}>Scikit-learn, PyCaret</li>
            <li style={{ marginBottom: "6px" }}>
              Keras, TensorFlow & Pytorch, Hugging Face
            </li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹06. Regression
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>Slop, Intercept</li>
            <li style={{ marginBottom: "6px" }}>Linear Regression</li>
            <li style={{ marginBottom: "6px" }}>Simple Linear Regression</li>
            <li style={{ marginBottom: "6px" }}>Multiple Linear Regression</li>
            <li style={{ marginBottom: "6px" }}>Ridge Regression</li>
            <li style={{ marginBottom: "6px" }}>Lasso Regression</li>
            <li style={{ marginBottom: "6px" }}>Logistic Regression</li>
            <li style={{ marginBottom: "6px" }}>Binary Classification</li>
            <li style={{ marginBottom: "6px" }}>Sigmoid Function</li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹07. Classification
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>K-Nearest Neighbors (KNN)</li>
            <li style={{ marginBottom: "6px" }}>Distance Metrics</li>
            <li style={{ marginBottom: "6px" }}>
              Manhattan (L1), Euclidean(L2) and Minkowski distance
            </li>
            <li style={{ marginBottom: "6px" }}>Choosing K</li>
            <li style={{ marginBottom: "6px" }}>Decision Trees</li>
            <li style={{ marginBottom: "6px" }}>Tree Structure</li>
            <li style={{ marginBottom: "6px" }}>
              Splitting Criteria (Gini, Entropy)
            </li>
            <li style={{ marginBottom: "6px" }}>Information Gain</li>
            <li style={{ marginBottom: "6px" }}>Pruning</li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹08. Clustering
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>
              Definition of Unsupervised Learning
            </li>
            <li style={{ marginBottom: "6px" }}>K-Means Clustering</li>
            <li style={{ marginBottom: "6px" }}>Initialization</li>
            <li style={{ marginBottom: "6px" }}>Iterative Optimization</li>
            <li style={{ marginBottom: "6px" }}>Hierarchical Clustering</li>
            <li style={{ marginBottom: "6px" }}>Agglomerative</li>
            <li style={{ marginBottom: "6px" }}>Dendrogram</li>
            <li style={{ marginBottom: "6px" }}>Elbow Method</li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹09. Model Training & Testing
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>Train/Test Split</li>
            <li style={{ marginBottom: "6px" }}>Validation Set</li>
            <li style={{ marginBottom: "6px" }}>Cross-Validation</li>
            <li style={{ marginBottom: "6px" }}>K-Fold Cross-Validation</li>
            <li style={{ marginBottom: "6px" }}>Bias-Variance Tradeoff</li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹10. Evaluation Metrics
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>Accuracy</li>
            <li style={{ marginBottom: "6px" }}>Precision</li>
            <li style={{ marginBottom: "6px" }}>Recall</li>
            <li style={{ marginBottom: "6px" }}>F1-Score</li>
            <li style={{ marginBottom: "6px" }}>Confusion Matrix</li>
            <li style={{ marginBottom: "6px" }}>K-Fold Cross Validation</li>
            <li style={{ marginBottom: "6px" }}>ROC Curve & AUC</li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹11. Feature Engineering & Selection
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>Feature Engineering</li>
            <li style={{ marginBottom: "6px" }}>Label Encoding</li>
            <li style={{ marginBottom: "6px" }}>One-Hot Encoding</li>
            <li style={{ marginBottom: "6px" }}>Binary Encoding</li>
            <li style={{ marginBottom: "6px" }}>Mean Encoding</li>
            <li style={{ marginBottom: "6px" }}>Frequency Encoding</li>
            <li style={{ marginBottom: "6px" }}>Ordinal Encoding</li>
            <li style={{ marginBottom: "6px" }}>
              Scaling (MinMax, Standardization)
            </li>
            <li style={{ marginBottom: "6px" }}>Polynomial Features</li>
            <li style={{ marginBottom: "6px" }}>Feature Selection</li>
            <li style={{ marginBottom: "6px" }}>
              Filter Methods (Correlation, Chi-Square)
            </li>
            <li style={{ marginBottom: "6px" }}>Wrapper Methods (RFE)</li>
            <li style={{ marginBottom: "6px" }}>
              Embedded Methods (Lasso, Tree-based importance)
            </li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹12. Cross-Validation
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>Hold-out Validation</li>
            <li style={{ marginBottom: "6px" }}>K-Fold Cross-Validation</li>
            <li style={{ marginBottom: "6px" }}>Stratified K-Fold</li>
            <li style={{ marginBottom: "6px" }}>
              Leave-One-Out Cross-Validation (LOOCV)
            </li>
            <li style={{ marginBottom: "6px" }}>
              Time Series Split (for sequential data)
            </li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹13. Overfitting & Underfitting
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>Overfitting</li>
            <li style={{ marginBottom: "6px" }}>
              High training accuracy, low test accuracy
            </li>
            <li style={{ marginBottom: "6px" }}>
              Caused by overly complex models
            </li>
            <li style={{ marginBottom: "6px" }}>Underfitting</li>
            <li style={{ marginBottom: "6px" }}>
              Low training and test accuracy
            </li>
            <li style={{ marginBottom: "6px" }}>
              Caused by overly simple models
            </li>
            <li style={{ marginBottom: "6px" }}>Solutions</li>
            <li style={{ marginBottom: "6px" }}>Regularization (L1, L2)</li>
            <li style={{ marginBottom: "6px" }}>Pruning</li>
            <li style={{ marginBottom: "6px" }}>More data</li>
            <li style={{ marginBottom: "6px" }}>Cross-validation</li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹14. Ensemble Methods
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>Bagging</li>
            <li style={{ marginBottom: "6px" }}>Random Forest</li>
            <li style={{ marginBottom: "6px" }}>Many Decision Trees</li>
            <li style={{ marginBottom: "6px" }}>Random feature selection</li>
            <li style={{ marginBottom: "6px" }}>Boosting</li>
            <li style={{ marginBottom: "6px" }}>Gradient Boosting</li>
            <li style={{ marginBottom: "6px" }}>Stage-wise learning</li>
            <li style={{ marginBottom: "6px" }}>
              Common tools: XGBoost, LightGBM, CatBoost
            </li>
            <li style={{ marginBottom: "6px" }}>Stacking</li>
            <li style={{ marginBottom: "6px" }}>Combines multiple models</li>
            <li style={{ marginBottom: "6px" }}>
              Uses meta-model to blend outputs
            </li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹15. Support Vector Machines (SVM)
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>Linear SVM</li>
            <li style={{ marginBottom: "6px" }}>Non-linear SVM</li>
            <li style={{ marginBottom: "6px" }}>
              Kernel Trick (RBF,Linear, Polynomial, Sigmoid)
            </li>
            <li style={{ marginBottom: "6px" }}>Hyperplanes and Margins</li>
            <li style={{ marginBottom: "6px" }}>Soft Margin vs. Hard Margin</li>
            <li style={{ marginBottom: "6px" }}>
              C parameter (regularization)
            </li>
            <li style={{ marginBottom: "6px" }}>Hyper plane</li>
            <li style={{ marginBottom: "6px" }}>Support vector</li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹16. Naive Bayes
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>Based on Bayes’ Theorem</li>
            <li style={{ marginBottom: "6px" }}>
              Prior, Posterior, Likelihood
            </li>
            <li style={{ marginBottom: "6px" }}>
              Assumes feature independence
            </li>
            <li style={{ marginBottom: "6px" }}>Types:</li>
            <li style={{ marginBottom: "6px" }}>
              Gaussian Naive Bayes (continuous data)
            </li>
            <li style={{ marginBottom: "6px" }}>
              Multinomial Naive Bayes (text data)
            </li>
            <li style={{ marginBottom: "6px" }}>
              Bernoulli Naive Bayes (binary data)
            </li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹17. Dimensionality Reduction
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>
              PCA (Principal Component Analysis)
            </li>
            <li style={{ marginBottom: "6px" }}>Linear projection</li>
            <li style={{ marginBottom: "6px" }}>Reduces feature space</li>
            <li style={{ marginBottom: "6px" }}>Keeps maximum variance</li>
            <li style={{ marginBottom: "6px" }}>
              t-SNE (t-distributed Stochastic Neighbor Embedding)
            </li>
            <li style={{ marginBottom: "6px" }}>Non-linear projection</li>
            <li style={{ marginBottom: "6px" }}>
              Best for visualization (2D/3D)
            </li>
            <li style={{ marginBottom: "6px" }}>Preserves local structure</li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹18. Introduction to Neural Networks
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>
              Inspired by biological neurons
            </li>
            <li style={{ marginBottom: "6px" }}>Composed of layers:</li>
            <li style={{ marginBottom: "6px" }}>Input Layer</li>
            <li style={{ marginBottom: "6px" }}>Hidden Layers</li>
            <li style={{ marginBottom: "6px" }}>Output Layer</li>
            <li style={{ marginBottom: "6px" }}>
              Processes inputs to produce predictions
            </li>
            <li style={{ marginBottom: "6px" }}>
              Types: Feedforward, Recurrent, Convolutional
            </li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹19. Loss Functions
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>Mean Squared Error (MSE):</li>
            <li style={{ marginBottom: "6px" }}>Mean Absolute Error (MAE):</li>
            <li style={{ marginBottom: "6px" }}>
              Root Mean Squared Error (RMSE):
            </li>
            <li style={{ marginBottom: "6px" }}>Used in regression</li>
            <li style={{ marginBottom: "6px" }}>
              Measures average squared difference
            </li>
            <li style={{ marginBottom: "6px" }}>Cross-Entropy Loss:</li>
            <li style={{ marginBottom: "6px" }}>Used in classification</li>
            <li style={{ marginBottom: "6px" }}>
              Measures probability distance
            </li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹21. Backpropagation & Gradient Descent
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>Backpropagation:</li>
            <li style={{ marginBottom: "6px" }}>
              Calculates gradients of loss w.r.t. weights
            </li>
            <li style={{ marginBottom: "6px" }}>
              Uses chain rule (partial derivatives)
            </li>
            <li style={{ marginBottom: "6px" }}>Gradient Descent:</li>
            <li style={{ marginBottom: "6px" }}>
              Updates weights using gradients
            </li>
            <li style={{ marginBottom: "6px" }}>Variants:</li>
            <li style={{ marginBottom: "6px" }}>Stochastic GD (SGD)</li>
            <li style={{ marginBottom: "6px" }}>Mini-batch GD</li>
            <li style={{ marginBottom: "6px" }}>Adam Optimizer</li>
            <li style={{ marginBottom: "6px" }}>Convex, NonConvex</li>
          </ul>

          <ul style={{ paddingLeft: "3px" }}>
            <li style={{ marginBottom: "3px", fontWeight: "bold" }}>
              🔹22. Final Project and Assignment
            </li>
          </ul>
          <ul style={{ listStyleType: "disc", paddingLeft: "25px" }}>
            <li style={{ marginBottom: "6px" }}>
              What you have learned already, you have to prove in your project
            </li>
          </ul>
        </div>
      </div>
    </HomeContainer>
  );
};

export default CoursePlan1;
